export default {
  props: {
    direction: {
      type: String
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pages/playground/PlaygroundCommon.js